import { render, staticRenderFns } from "./TableImportFieldYieldsContainer.vue?vue&type=template&id=627b5ef2&"
import script from "./TableImportFieldYieldsContainer.vue?vue&type=script&lang=js&"
export * from "./TableImportFieldYieldsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports